// used to scale printarea or design up or down
// to calculate scale: new width / old width

// example:
//    const mockupwidth = 1000
//    const previewwidth = 300
//    const printarea = { top: 100, left: 100, width: 500, height: 500 }
//    const scale = previewwidth / mockupwidth
//    scaleTo(printarea, scale)
//    => {top: 30, left: 30, width: 150, height: 150}

export const scaleTo = ({ top, left, width, height }, scale) => {
  return {
    top: top * scale,
    left: left * scale,
    width: width * scale,
    height: height * scale,
  }
}

// const design = {
//   url: null,
//   top: 0.2,
//   left: 0.2,
//   width: 0.6,
//   aspect: 1,
// }

export const mapDesignToArea = (design, area) => {
  const designTop = Math.max(0, design.top * area.height)
  const designLeft = Math.max(0, design.left * area.width)
  const designWidth = Math.min(design.width * area.width, area.width)
  const designHeight = Math.min(designWidth / design.aspect, area.height)
  return {
    width: designWidth,
    height: designHeight,
    top: Math.min(designTop, area.height - designHeight),
    left: Math.min(designLeft, area.width - designWidth),
  }
}

export const getDefaultImagePlacement = (src, printarea) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onerror = reject
    img.onload = () => {
      const scale = printarea.width / img.width
      resolve({
        top: 0,
        left: 0,
        width: Math.min(img.width, img.width * scale),
        aspect: img.width / img.height,
      })
    }
    img.src = src
  })
}



// WEBPACK FOOTER //
// ./src/products/add/utils.js